import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import VistaPreviaPresupuestoPDF from "./VistaPreviaPresupuestoPDF";
import axios from '../../axios/axiosconf';

function ListadoPresupuestos() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [presupuestos, setPresupuestos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [pacientes, setPacientes] = useState([]);
    const [encabezadosPersonalizados, setEncabezadosPersonalizados] = useState({});
    
    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [usuarioFiltro, setUsuarioFiltro] = useState('');
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    
    // Selección de presupuesto
    const [presupuestoSeleccionadoId, setPresupuestoSeleccionadoId] = useState(null);
    
    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const registrosPorPagina = 12;

    useEffect(() => {
        // Establecer fechas de la semana actual por defecto
        const hoy = new Date();
        const inicioSemana = new Date(hoy.setDate(hoy.getDate() - hoy.getDay()));
        const finSemana = new Date(hoy.setDate(hoy.getDate() - hoy.getDay() + 6));
        
        setFechaInicio(inicioSemana.toISOString().split('T')[0]);
        setFechaFin(finSemana.toISOString().split('T')[0]);

        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar usuarios del cliente
        axios.get('/users-by-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes
        axios.get('/pacientes?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            cargarPresupuestos();
        }
    }, [loggedIn, fechaInicio, fechaFin, usuarioFiltro]);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            const timeoutId = setTimeout(() => {
                cargarPresupuestos();
            }, 500);
            return () => clearTimeout(timeoutId);
        }
    }, [busquedaPaciente]);

    const cargarPresupuestos = () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (usuarioFiltro) params.append('usuario_id', usuarioFiltro);
        if (busquedaPaciente) params.append('busqueda_paciente', busquedaPaciente);

        console.log('Parámetros enviados:', params.toString());
        
        axios.get('/presupuestos?' + params.toString(), config)
            .then(response => {
                if (response.status === 200) {
                    setPresupuestos(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    };

    const getNombrePaciente = (pacienteId) => {
        const paciente = pacientes.find(p => p.id === pacienteId);
        if (paciente) {
            return `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        }
        return 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id === usuarioId);
        return usuario ? usuario.name : 'N/A';
    };

    const vistaPreviaPresupuesto = (presupuestoId) => {
        const url = `${window.location.origin}/smile/#/vista-previa-presupuesto/${presupuestoId}`;
        window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const descargarPDFPresupuesto = async (presupuestoId) => {
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            
            // Cargar datos del presupuesto
            const presupuestoResponse = await axios.get(`/presupuesto/${presupuestoId}?uid=${userdata.user_id}`);
            const presupuestoData = presupuestoResponse.data;
            
            // Buscar paciente
            const pacienteData = pacientes.find(p => p.id === presupuestoData.paciente_id);
            
            // Buscar usuario
            const usuarioData = usuarios.find(u => u.id === presupuestoData.users_id);
            
            // Cargar encabezado personalizado si existe
            let encabezadoData = null;
            if (presupuestoData.users_id) {
                try {
                    const encabezadoResponse = await axios.get(`/encabezado-personalizado?uid=${presupuestoData.users_id}`);
                    if (encabezadoResponse.status === 200 && encabezadoResponse.data && encabezadoResponse.data.estado === 1) {
                        encabezadoData = encabezadoResponse.data;
                    }
                } catch (error) {
                    console.log('No hay encabezado personalizado para este usuario');
                }
            }
            
            // Crear contenedor temporal
            const contenedorTemporal = document.createElement('div');
            contenedorTemporal.style.position = 'absolute';
            contenedorTemporal.style.left = '-9999px';
            contenedorTemporal.style.top = '0';
            document.body.appendChild(contenedorTemporal);
            
            // Renderizar componente PDF
            ReactDOM.render(
                <VistaPreviaPresupuestoPDF
                    presupuesto={presupuestoData}
                    client={client}
                    paciente={pacienteData}
                    encabezadoPersonalizado={encabezadoData}
                    usuario={usuarioData}
                />,
                contenedorTemporal
            );
            
            // Esperar a que se renderice
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Generar PDF
            const html2pdf = await import('html2pdf-fix-jspdf');
            const element = document.getElementById('presupuesto-pdf-editable');
            
            const opt = {
                margin: 10,
                filename: `presupuesto-${presupuestoData.numero_presupuesto}.pdf`,
                image: { type: 'jpeg', quality: 0.95 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    letterRendering: true
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'letter',
                    orientation: 'portrait',
                    compress: true
                },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                }
            };
            
            // Generar y guardar el PDF directamente
            await html2pdf.default().from(element).set(opt).save();
            
            // Limpiar
            document.body.removeChild(contenedorTemporal);
            
        } catch (error) {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intente nuevamente.');
        }
    };

    const enviarEmailPresupuesto = (presupuestoId) => {
        alert('Funcionalidad de envío de email en desarrollo. Por ahora puede descargar el PDF y enviarlo manualmente.');
        // TODO: Implementar modal de email similar a InformacionFactura.js
    };

    const getPresupuestoSeleccionado = () => {
        return presupuestos.find(p => p.id === presupuestoSeleccionadoId);
    };

    const handleSeleccionPresupuesto = (presupuestoId) => {
        setPresupuestoSeleccionadoId(presupuestoSeleccionadoId === presupuestoId ? null : presupuestoId);
    };

    // Calcular presupuestos paginados
    const indiceUltimoRegistro = paginaActual * registrosPorPagina;
    const indicePrimerRegistro = indiceUltimoRegistro - registrosPorPagina;
    const presupuestosPaginados = presupuestos.slice(indicePrimerRegistro, indiceUltimoRegistro);
    const totalPaginas = Math.ceil(presupuestos.length / registrosPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
        setPresupuestoSeleccionadoId(null);
    };

    // Resetear a página 1 cuando cambien los filtros
    useEffect(() => {
        setPaginaActual(1);
    }, [fechaInicio, fechaFin, usuarioFiltro, busquedaPaciente]);

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <style>{`
                    .table-info {
                        background-color: #f6fcfd !important;
                        border-left: 4px solid #17a2b8;
                    }
                    .table tbody tr:hover {
                        background-color: #f6fcfd;
                        transform: scale(1.001);
                        transition: all 0.2s ease;
                    }
                    .table tbody tr.table-info:hover {
                        background-color: #e6f7f9 !important;
                        box-shadow: 0 2px 4px rgba(23, 162, 184, 0.15);
                    }
                    .card-header.bg-gradient-light {
                        background: linear-gradient(135deg, #f6fcfd 0%, #e6f7f9 100%);
                        border-bottom: 2px solid #17a2b8;
                    }
                    .shadow-sm {
                        box-shadow: 0 0.125rem 0.25rem rgba(23, 162, 184, 0.1) !important;
                    }
                    .table th {
                        background-color: #282828;
                        color: #f6fcfd;
                        border-top: none;
                        font-weight: 600;
                        font-size: 0.9rem;
                        vertical-align: middle;
                    }
                    .table td {
                        vertical-align: middle;
                        font-size: 0.9rem;
                    }
                    .card-primary.card-outline {
                        border-top: 3px solid #17a2b8;
                    }
                    .card-info.card-outline {
                        border-top: 3px solid #17a2b8;
                    }
                    .pagination .page-item.active .page-link {
                        background-color: #282828;
                        border-color: #282828;
                        color: #f6fcfd;
                    }
                    .pagination .page-link {
                        color: #282828;
                        border-color: #dee2e6;
                    }
                    .pagination .page-link:hover {
                        background-color: #f6fcfd;
                        border-color: #17a2b8;
                        color: #282828;
                    }
                    .pagination .page-item.disabled .page-link {
                        color: #6c757d;
                        background-color: #fff;
                        border-color: #dee2e6;
                    }
                    .badge-outline {
                        background-color: transparent;
                        border-width: 1px;
                        border-style: solid;
                    }
                    .badge-outline-info {
                        color: #17a2b8;
                        border-color: #17a2b8;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item active">Listado de Presupuestos</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Listado de Presupuestos</h1>
                                </div>
                                <div className="col-sm-4">
                                    <Link to="/crear-presupuesto" className="btn btn-primary float-right">
                                        <i className="fas fa-plus"></i> Nuevo Presupuesto
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            {/* Filtros */}
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <h5><b>Filtros</b></h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Fecha Inicio</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fechaInicio}
                                                    onChange={(e) => setFechaInicio(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Fecha Fin</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fechaFin}
                                                    onChange={(e) => setFechaFin(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Usuario</label>
                                                <select 
                                                    className="form-control" 
                                                    value={usuarioFiltro}
                                                    onChange={(e) => setUsuarioFiltro(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    {usuarios.map(usuario => (
                                                        <option key={usuario.id} value={usuario.id}>{usuario.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Buscar Paciente</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Nombre del paciente..."
                                                    value={busquedaPaciente}
                                                    onChange={(e) => setBusquedaPaciente(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Barra de acciones */}
                            {presupuestoSeleccionadoId && (
                                <div className="card card-primary card-outline shadow-sm">
                                    <div className="card-header bg-gradient-light">
                                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                                            <div className="d-flex align-items-center flex-wrap">
                                                <h6 className="mb-0 mr-3" style={{fontSize: '0.95rem'}}>
                                                    <i className="fas fa-check-circle text-success"></i> 
                                                    <strong>Presupuesto N° {getPresupuestoSeleccionado()?.numero_presupuesto}</strong>
                                                </h6>
                                                <div className="d-flex flex-wrap">
                                                    <span className="mr-2 mb-1">
                                                        <span className="badge badge-lg badge-outline-info" style={{borderColor: '#17a2b8', color: '#17a2b8', fontSize: '1.1rem', padding: '8px 12px'}}>
                                                            <i className="fas fa-dollar-sign mr-1"></i>
                                                            Total: ${Math.round(parseFloat(getPresupuestoSeleccionado()?.valor_total || 0)).toLocaleString('es-CO')}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                            <button 
                                                className="btn btn-sm btn-outline-secondary mt-2 mt-md-0"
                                                onClick={() => setPresupuestoSeleccionadoId(null)}
                                            >
                                                <i className="fas fa-times"></i> Deseleccionar
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body py-3">
                                        <div className="btn-toolbar" role="toolbar">
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <Link 
                                                    to={`/editar-presupuesto/${presupuestoSeleccionadoId}`} 
                                                    className="btn btn-secondary"
                                                    title="Editar Presupuesto"
                                                >
                                                    <i className="fas fa-edit"></i> Editar
                                                </Link>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <Link 
                                                    to={`/crear-factura?presupuesto=${presupuestoSeleccionadoId}`}
                                                    className="btn btn-primary"
                                                    title="Crear Factura Electrónica"
                                                >
                                                    <i className="fas fa-bolt"></i> Factura Electrónica
                                                </Link>
                                                <Link 
                                                    to={`/crear-factura-no-electronica?presupuesto=${presupuestoSeleccionadoId}`}
                                                    className="btn btn-primary"
                                                    title="Crear Factura No Electrónica"
                                                >
                                                    <i className="fas fa-file-alt"></i> Factura No Electrónica
                                                </Link>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-info"
                                                    onClick={() => vistaPreviaPresupuesto(presupuestoSeleccionadoId)}
                                                    title="Vista previa del presupuesto"
                                                >
                                                    <i className="fas fa-eye"></i> Vista Previa
                                                </button>
                                                <button 
                                                    className="btn btn-success"
                                                    onClick={() => enviarEmailPresupuesto(presupuestoSeleccionadoId)}
                                                    title="Enviar presupuesto por correo electrónico"
                                                >
                                                    <i className="fas fa-envelope"></i> Email
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Tabla de presupuestos */}
                            <div className="card card-info card-outline">
                                <div className="card-body p-0" style={{overflowX: 'auto'}}>
                                    <table className="table table-bordered table-hover" style={{marginBottom: 0}}>
                                        <thead>
                                            <tr>
                                                <th width="50">Seleccionar</th>
                                                <th>N° Presupuesto</th>
                                                <th>Fecha Creación</th>
                                                <th>Paciente</th>
                                                <th>Usuario</th>
                                                <th>Valor Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {presupuestosPaginados.map(presupuesto => (
                                                <tr 
                                                    key={presupuesto.id}
                                                    className={presupuestoSeleccionadoId === presupuesto.id ? 'table-info' : ''}
                                                    style={{cursor: 'pointer'}}
                                                    onClick={() => handleSeleccionPresupuesto(presupuesto.id)}
                                                >
                                                    <td className="text-center">
                                                        <input 
                                                            type="radio" 
                                                            name="presupuestoSeleccionado"
                                                            checked={presupuestoSeleccionadoId === presupuesto.id}
                                                            onChange={() => handleSeleccionPresupuesto(presupuesto.id)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </td>
                                                    <td><strong>{presupuesto.numero_presupuesto}</strong></td>
                                                    <td>{new Date(presupuesto.fecha_creacion).toLocaleDateString()}</td>
                                                    <td>
                                                        <span title={getNombrePaciente(presupuesto.paciente_id)}>
                                                            {getNombrePaciente(presupuesto.paciente_id).length > 25 
                                                                ? getNombrePaciente(presupuesto.paciente_id).substring(0, 25) + '...' 
                                                                : getNombrePaciente(presupuesto.paciente_id)
                                                            }
                                                        </span>
                                                    </td>
                                                    <td>{getNombreUsuario(presupuesto.users_id)}</td>
                                                    <td className="text-right">
                                                        <strong>${Math.round(parseFloat(presupuesto.valor_total)).toLocaleString('es-CO')}</strong>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {presupuestos.length === 0 && (
                                        <div className="text-center p-4">
                                            <p>No se encontraron presupuestos para los filtros seleccionados.</p>
                                        </div>
                                    )}
                                </div>
                                
                                {/* Paginador */}
                                {presupuestos.length > registrosPorPagina && (
                                    <div className="card-footer clearfix">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <p className="mb-0">
                                                    Mostrando {indicePrimerRegistro + 1} a {Math.min(indiceUltimoRegistro, presupuestos.length)} de {presupuestos.length} registros
                                                </p>
                                            </div>
                                            <div className="col-md-6">
                                                <ul className="pagination pagination-sm m-0 float-right">
                                                    <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                                        <button 
                                                            className="page-link" 
                                                            onClick={() => cambiarPagina(paginaActual - 1)}
                                                            disabled={paginaActual === 1}
                                                        >
                                                            «
                                                        </button>
                                                    </li>
                                                    
                                                    {[...Array(totalPaginas)].map((_, index) => {
                                                        const numeroPagina = index + 1;
                                                        if (
                                                            numeroPagina === 1 ||
                                                            numeroPagina === totalPaginas ||
                                                            (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)
                                                        ) {
                                                            return (
                                                                <li 
                                                                    key={numeroPagina} 
                                                                    className={`page-item ${paginaActual === numeroPagina ? 'active' : ''}`}
                                                                >
                                                                    <button 
                                                                        className="page-link" 
                                                                        onClick={() => cambiarPagina(numeroPagina)}
                                                                    >
                                                                        {numeroPagina}
                                                                    </button>
                                                                </li>
                                                            );
                                                        } else if (
                                                            numeroPagina === paginaActual - 2 ||
                                                            numeroPagina === paginaActual + 2
                                                        ) {
                                                            return <li key={numeroPagina} className="page-item disabled"><span className="page-link">...</span></li>;
                                                        }
                                                        return null;
                                                    })}
                                                    
                                                    <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                                        <button 
                                                            className="page-link" 
                                                            onClick={() => cambiarPagina(paginaActual + 1)}
                                                            disabled={paginaActual === totalPaginas}
                                                        >
                                                            »
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>
                    </section>
                </div>

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default ListadoPresupuestos;